import { Component } from 'react';

const RELOAD_COOLDOWN_MS = 10_000;

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, reloadBlocked: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Report error to server for debugging
    try {
      fetch('/api/client-error', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: error?.message,
          stack: error?.stack,
          componentStack: errorInfo?.componentStack?.slice(0, 1000),
        }),
      }).catch(() => {});
    } catch {}
  }

  handleReload = () => {
    const now = Date.now();
    try {
      const lastReload = Number(sessionStorage.getItem('cts_last_error_reload')) || 0;
      if (now - lastReload < RELOAD_COOLDOWN_MS) {
        this.setState({ reloadBlocked: true });
        return;
      }
      sessionStorage.setItem('cts_last_error_reload', String(now));
    } catch {
      // sessionStorage unavailable — allow reload
    }
    this.setState({ hasError: false, error: null, reloadBlocked: false });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 dark:bg-slate-900 px-4">
          <div className="bg-white dark:bg-slate-800 border border-gray-200 dark:border-slate-700 rounded-xl shadow-lg p-8 max-w-md text-center">
            <h1 className="text-xl font-bold text-gray-900 dark:text-gray-100 mb-2">Something went wrong</h1>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-4">
              {this.state.reloadBlocked
                ? 'This error persists after reloading. Please contact support.'
                : 'An unexpected error occurred. Please try refreshing the page.'}
            </p>
            {!this.state.reloadBlocked && (
              <button
                onClick={this.handleReload}
                className="px-4 py-2 bg-primary text-white rounded-lg text-sm font-medium hover:bg-primary/90 transition-colors"
              >
                Refresh Page
              </button>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
